
import { useEffect, useState } from 'react';
import Button from '../base/Button';

export default function Hero() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const openWhatsApp = () => {
    window.open('https://wa.me/5544988010206?text=Hello, I would like to talk about Social Security Law', '_blank');
  };

  const scrollToForm = () => {
    const element = document.getElementById('formulario');
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section id="inicio" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Video */}
      <div className="absolute inset-0 bg-gradient-to-br from-gray-900 via-black to-gray-800">
        <video 
          autoPlay
          muted
          loop
          playsInline
          className="w-full h-full object-cover object-center opacity-30"
        >
          <source src="https://public.readdy.ai/ai/video_res/afcf17f2-7f44-4e23-b4bc-33589609e571.mp4" type="video/mp4" />
        </video>
      </div>
      
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black/60"></div>
      
      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 py-20">
        <div className="max-w-4xl mx-auto text-center">
          <div className={`transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-serif font-bold text-white mb-6 leading-tight">
              Transparency and security in{' '}
              <span className="text-[#b86846]">Social Security Law</span>
            </h1>
            
            <p className="text-xl md:text-2xl text-gray-300 mb-8 max-w-3xl mx-auto leading-relaxed">
              Social security planning and defense in simple language, for those who cannot make mistakes with INSS
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <Button 
                size="lg" 
                onClick={openWhatsApp}
                className="w-full sm:w-auto"
              >
                <i className="ri-whatsapp-line mr-2"></i>
                Talk on WhatsApp now
              </Button>
              
              <Button 
                variant="outline" 
                size="lg" 
                onClick={scrollToForm}
                className="w-full sm:w-auto"
              >
                Find out if you are entitled to benefits
              </Button>
            </div>
          </div>
        </div>
      </div>
      
      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white animate-bounce">
        <i className="ri-arrow-down-line text-2xl"></i>
      </div>
    </section>
  );
}
